module.exports = __webpack_public_path__ + "img/icon_building.4e7831a7.svg";